"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}Object.defineProperty(exports,"__esModule",{value:!0});const t=e(require("styled-components")).default.div`
    .input_header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 1rem;
        p {
            margin: 0;
            line-height: 1.25rem;
            font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
            font-size: ${({theme:e})=>e.typography.p.fontSize};
        }
        .info_circle_tooltip {
            svg {
                height: 17px;
                width: 17px;
                pointer-events: none;
            }
        }
        .header_section {
            display: flex;
            gap: 0.25rem;
            align-items: center;
            .DXTooltip-trigger {
                background: transparent;
                border: none;
            }
            .DXTooltip-content {
                font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
            }
        }
    }
    .slider {
        position: relative;
        .fill {
            position: absolute;
            top: 4px;
            left: 0;
            width: 100%;
            height: 9px;
            border-radius: 5px;
            z-index: 1;
            overflow: hidden;
        }
        .upper {
            height: 100%;
            width: 100%;
            background: ${({theme:e})=>e.colors.primary.default};
            transform-origin: 0 0;
            position: absolute;
            top: 0;
            left: 0;
        }
        .lower {
            height: 100%;
            width: 100%;
            background: ${({theme:e})=>e.colors.grey[300]};
        }
    }
    input[type='range'] {
        width: 100%;
        appearance: none;
        background: transparent;
        color: ${({theme:e})=>e.colors.primary.default};
        height: 9px;
        border-radius: 5px;
        position: relative;
        z-index: 3;
        &::-webkit-slider-thumb {
            position: relative;
            appearance: none;
            height: 30px;
            width: 30px;
            background: ${({theme:e})=>e.colors.common.light};
            border: solid 1px ${({theme:e})=>e.colors.primary.default};
            border-radius: 100%;
            cursor: pointer;
            transform: translate(-1.75px, -2px);
        }
        &::-moz-range-thumb {
            position: relative;
            appearance: none;
            height: 30px;
            width: 30px;
            background: ${({theme:e})=>e.colors.common.light};
            border: solid 1px ${({theme:e})=>e.colors.primary.default};
            border-radius: 100%;
            cursor: pointer;
            transform: translate(-1.75px, 0);
        }
        &:focus {
            outline: none;
        }
    }
    .field {
        background: transparent;
        outline: none;
        border-bottom: solid 1px ${({theme:e})=>e.colors.grey[300]};
        display: flex;
        flex-direction: row;
        width: 27%;
        .prefix {
            margin-right: 0.25rem;
            margin-top: 0.25rem;
        }
        .suffix {
            margin-top: 0.25rem;
        }
        input {
            border: none;
            margin: 0;
            font-size: 18px;
            line-height: 1rem;
            letter-spacing: normal;
            font-family: ${({theme:e})=>e.fonts.primary.fontFamily};
            font-weight: normal;
            width: 100%;
        }
    }
`;exports.StyledRangeInput=t,exports.default=t;
//# sourceMappingURL=styles.js.map
